<template>
    <div id="pageAll">
        <div id="all">
            <botPageLeft :indexArr="[3,0]" @title="getData"/>
            <div class="contAll">
                <div class="menuTitle">
                    <div class="title1">{{titleArr[0]}} ></div>
                    <div class="title2">{{titleArr[1]}}</div>
                </div>
                <div class="cont">
                    <div class="question">{{contData[0]}}</div>
                    <div class="answer">{{contData[1]}}</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import botPageLeft from '../../components/botPageLeft.vue'
export default {
  name: 'companySituation',
  components: { botPageLeft },
  data () {
    return {
      titleArr: [], // 标题
      contData: [
        '印小生特色（公司介绍）',
        '印小生的成立，是为了成为行业独角兽目标而打造的一个全新综合性服务平台，从前端商品的提供，到后端一键服务呼叫系统的平台。通过整合线上和线下资源，线上打通和其他平台的合作，线下整合各品牌厂家资源，从上游的产品链到覆盖全国所有省市自治区的经销商服务网络资源，真正可以做到面向全国的线上租赁服务平台。印小生围绕这个业务打造的信息平台，通过crm客户管理软件结合每台租赁机器带的终端智能盒子，可以全方位的管理机器、保证机器安全、监管设备使用情况及售后解决情况。通过微信公众号定期给客户推送促销或者抽奖活动，增加客户粘性。印小生的微信小程序也会和crm对接，把服务的客户信息对接到crm客户管理软件里来进行管理。我们未来会把前期落地服务商用加盟的方式引入到我们印小生的平台，纳入统一管理的平台，让整个服务团队有统一的服务流程、统一的服务标准，有严格的考核机制，一年设立两次考核，另外平时会通过客户风评来进行优胜略汰，达不到标准的会请出平台，同时也会不断引进有服务意识和共同目标的人加入平台，保证平台的合理流转。而我们不光是针对服务进行考核，同时我们也会针对服务做各种培训，有服务意识、服务态度、专业知识等方面的培训，服务的产品会延伸到整个办公应用领域里的设备和软件。'
      ]
    }
  },
  methods: {
    getData (e) {
      console.log(e)
      this.titleArr = e
    }
  }
}
</script>

<style scoped>
    .contAll{
        width: 997px;
        min-height: 800px;
        background: #fff;
        padding: 40px;
        box-sizing: border-box;
    }
    .content{
        margin-top: 20px;
    }
    .title{
        font-size: 14px;
        font-weight: 700;
        color: #666;
        line-height: 28px;
    }
    .question{
        width: 100%;
        text-align: center;
        margin: 20px 0;
        line-height: 28px;
        font-size: 18px;
        font-weight: 700;
        color: #666;
    }
    .answer{
        color: #999;
        line-height: 28px;
        font-size: 12px;
    }
</style>
